import { EmployerFooter, EmployerHeader } from '@seek/adv-header-footer';
import { Box, Page, Stack } from 'braid-design-system';

import { linkRenderer } from 'src/App/Components/TrackingLink/TrackingLink';
import { ErrorPage } from 'src/App/Pages/ErrorPage/ErrorPage';
import { useAccountContext } from 'src/hooks/use-account-context';
import { useConfig } from 'src/modules/ConfigProvider';

export interface Props {
  children?: any;
}

export const MainLayout = ({ children }: Props) => {
  const { site, locale, isStaging } = useConfig();
  const { data: accountContext, error } = useAccountContext();
  return (
    <Page
      footer={
        <EmployerFooter
          site={site}
          locale={locale}
          isStaging={isStaging}
          linkRenderer={linkRenderer('global-footer')}
          advertiser={accountContext?.headerFooterContext?.advertiser}
          identityContext={accountContext?.headerFooterContext?.identityContext}
        />
      }
    >
      <Stack space="xlarge">
        <EmployerHeader
          activeTabId="account"
          site={site}
          locale={locale}
          isStaging={isStaging}
          linkRenderer={linkRenderer('global-header')}
          advertiser={accountContext?.headerFooterContext?.advertiser}
          identityContext={accountContext?.headerFooterContext?.identityContext}
          user={accountContext?.headerFooterContext?.user}
          divider
        />
        <Box component="main">
          {error ? (
            <ErrorPage error={error} site={site} locale={locale} />
          ) : (
            children
          )}
        </Box>
      </Stack>
    </Page>
  );
};
